export const SET_RETURN_ITEMS = 'SET_RETURN_ITEMS';
export const SET_CART_ACTIONS = 'SET_CART_ACTIONS';

export const setReturnItems =
  (returnItems = []) =>
  (dispatch) => {
    dispatch({
      type: SET_RETURN_ITEMS,
      data: { returnItems },
    });
  };

export const setCartActions = (cartActions) => ({
  type: SET_CART_ACTIONS,
  data: {
    cartActions,
  },
});
